import ScoreCard from './ScoreCard.vue';
import RecentScoreCards from './RecentScoreCards.vue';

export const scorecardRoutesV2 = [
    {
        path: '/scorecard',
        name: 'ScorecardV2',
        component: ScoreCard,
        meta: {
            requiresAuth: true,
            accessId: 'scorecard',
        }
    },
    {
        path: '/scorecard/recent',
        name: 'ScorecardRecent',
        component: RecentScoreCards,
        meta: {
            requiresAuth: true,
            accessId: 'scorecard',
        }
    }
]
